import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { products } from '../data/products';

const RelatedProducts = ({ currentProductId, currentCategory, limit = 4 }) => {
  // 获取相关产品 - 排除当前产品和同类别产品，随机选择
  const getRelatedProducts = () => {
    const filteredProducts = products.filter(product => 
      product.id !== currentProductId && 
      product.category !== currentCategory
    );
    
    // 随机打乱数组并取前limit个
    const shuffled = [...filteredProducts].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, limit);
  };

  const relatedProducts = getRelatedProducts();

  return (
    <div className="mt-16">
      <h2 className="text-2xl font-bold text-white mb-8">Related Products</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {relatedProducts.map((product) => (
          <motion.div
            key={product.id}
            whileHover={{ y: -5 }}
            className="bg-gray-800 rounded-lg overflow-hidden"
          >
            <Link to={`/product/${product.id}`}>
              <img 
                src={product.image} 
                alt={product.name} 
                className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                onError={(e) => { e.target.src = '/images/products/placeholder.jpg'; }}
              />
            </Link>
            <div className="p-4">
              <Link to={`/product/${product.id}`}>
                <h3 className="text-white font-medium mb-2 hover:text-green-400 transition-colors">
                  {product.name}
                </h3>
              </Link>
              <p className="text-gray-400 text-sm mb-3 line-clamp-2">{product.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-white font-bold">{product.price}</span>
                <Link 
                  to={`/product/${product.id}`}
                  className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm transition-colors"
                >
                  View Details
                </Link>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;
